import { Routes, Route } from 'react-router-dom';
import { publicRoutes } from './public.routes';
import { authRoutes } from './auth.routes';
import { userRoutes } from './user.routes';
import { adminRoutes } from './admin.routes';
import { NotFoundScreen } from '../screens';

export function AppRoutes() {
  return (
    <Routes>
      {/* Public Routes - Accessible to everyone */}
      {publicRoutes}
      
      {/* Auth Routes - Login, Register, etc. */}
      {authRoutes}
      
      {/* User Routes - Protected user routes */}
      {userRoutes}
      
      {/* Admin Routes - Protected admin routes */}
      {adminRoutes}
      
      {/* 404 - Catch all unmatched routes */}
      <Route path="*" element={<NotFoundScreen />} />
    </Routes>
  );
}

